import { useTSContext } from '../../context/Dashboard/contextTScore';
import { ScoreCard } from './ScoreCard';
import { ScoreCardMisconfig } from './ScoreCardCloudMisconfig';
import SecondaryData from './SecondaryData';

const CardView = () => {
  const { 
    webData, 
    networkData, 
    cloudData,
    webTVulScore,
    webCVulScore,
    webSaveScore,
    networkTVulScore,
    networkCVulScore,
    networkSaveScore,
    cloudTVulScore,
    cloudCVulScore,
    cloudSaveScore,  

    cloudMisconfigData,
    cloudMisconfigAll,
    cloudCriticalScore,
    cloudWarningScore,
  } = useTSContext();
  
  const renderCustomizedLabel = ({ name, value }) => `${name}: ${value}`;
  const filteredWebData = webData.filter((data) => data.value > 0);
  const filteredNetworkData = networkData.filter((data) => data.value > 0);
  const filteredCloudData = cloudData.filter((data) => data.value > 0);
  const filteredCloudMisconfigData = cloudMisconfigData.filter((data) => data.value > 0);
  
  return (
    <div className="d-flex flex-column align-items-start overall-card p-2">
      <div className='d-flex flex-wrap gap-3'>
        <div>
          <ScoreCard
            title="Web Score"
            data={filteredWebData}
            totalVul={webTVulScore}
            criticalVul={webCVulScore}
            saveScore={webSaveScore}
          />
          <ScoreCard
            title="Network Score"
            data={filteredNetworkData}
            totalVul={networkTVulScore}
            criticalVul={networkCVulScore}
            saveScore={networkSaveScore}
          />
          <ScoreCard
            title="Cloud Score"
            data={filteredCloudData}
            totalVul={cloudTVulScore}
            criticalVul={cloudCVulScore}
            saveScore={cloudSaveScore}
          />
          <ScoreCardMisconfig
            title="Cloud Misconfig."
            data={filteredCloudMisconfigData}
            totalMisconfig={cloudMisconfigAll}
            criticalMisconfig={cloudCriticalScore}
            warningMisconfig={cloudWarningScore}
          />
        </div>
        <SecondaryData />
      </div>
    </div>
  );
};

export default CardView;